export { WebfleetObjectCard } from "./webfleet-object-card";
